export class PreloadStrategy {
  // On the homepage, warm the /products route chunk during idle time. "Shop Now"
  // is the primary hero action, so /products is by far the most likely next
  // destination — and on a cold load its chunk isn't otherwise requested until
  // the click, then it has to download+parse behind the entry/vendor JS (S57
  // "gate B"). The per-link hover/touch handlers (prefetchProductsRoute.ts) fire
  // even earlier when they can; this covers the no-hover / didn't-hover case.
  static prefetchProductsRoute() {
    if (window.location.pathname !== '/') return;
    const run = () => { import('@/pages/Products').catch(() => {}); };
    if ('requestIdleCallback' in window) {
      (window as unknown as { requestIdleCallback: (cb: () => void, opts?: { timeout: number }) => void })
        .requestIdleCallback(run, { timeout: 4000 });
    } else {
      setTimeout(run, 2500);
    }
  }

  static initializePreloading() {
    // preloadCriticalImages() was removed (Stage 3d): it preloaded 6 category tiles from raw
    // Supabase URLs, but the tiles render from img.veevoerwinkel.co.za, so Chrome reported every
    // one as "preloaded but not used". The homepage's real image preloads live in index.html's
    // inline head script (filled in by scripts/prerender-homepage.tsx).
    this.prefetchProductsRoute();
  }
}